
// export const baseURL = "http://192.168.1.101:8000/api";

// export const urlimage = "http://192.168.1.101:8000";


export const baseURL =  process.env.REACT_APP_BASE_URL || "http://127.0.0.1:8000/api";

export const urlimage = process.env.REACT_APP_IMAGE_URL || "http://127.0.0.1:8000";




export const tenantURL = (slug, path = "") => {
  if (!slug) {
    throw new Error("tenantURL() appelé sans slug d'établissement.");
  }
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `${baseURL}/${slug}/${cleanPath}`;
};






